export default {
      id: "social-01-usage",
      viewBox: "0 0 9 20",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#social-01",
      toString: function () {
        return this.url;
      }
    }